import React from "react";
import { Container, Col, Row } from "reactstrap";
import styled, { css } from "react-emotion";
import egg from "../../static/img/ei.jpg";

const LeftColumn = styled("div")`
  background-color: #0055a4;
  color: #fff;
  font-size: 18px;
  line-height: 16px;
  font-weight: 100;
  padding: 30px;
  text-transform: uppercase;
  min-height: 100%;
}
@media (max-width: 991px) {
  -webkit-clip-path: polygon(0 0, 100% 0%, 60% 100%, 0% 100%);
  clip-path: polygon(0 0, 100% 0%, 60% 100%, 0% 100%);
  }
}

@media (min-width: 992px) {
  -webkit-clip-path: polygon(0 0, 100% 0%, 40% 100%, 0% 100%);
  clip-path: polygon(0 0, 100% 0%, 40% 100%, 0% 100%);
  }
`;

const RightColumn = styled("div")`
  color: #0055a4;
  font-size: 18px;
  font-weight: lighter;
  padding: 15px;
  text-align: right;
`;

const Egg = styled("div")`
  background-image: url(${egg});
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100%;
`;

export default class Contactcard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <footer>
        <Container>
          <Row className="mt-5 mb-3 no-gutters">
            <Col className="d-none d-lg-block" lg="4" xs="12">
              <Egg />
            </Col>
            <Col style={{ border: "1px solid" }} lg="8" className="p-1">
              <Row>
                <Col className="d-none d-md-block" md="6" xs="12">
                  <LeftColumn>
                    <p>Arbeitsplatten</p>
                    <p>Fensterbänke</p>
                    <p>Waschtische</p>
                    <p>Theken</p>
                    <p>Stufen</p>
                    <p>Bad</p>
                  </LeftColumn>
                </Col>
                <Col md="6" xs="12">
                  <RightColumn>
                    <p style={{ textTransform: "uppercase" }}>
                      Geschäftszeiten
                    </p>
                    <p>
                      <span style={{ fontWeight: "bolder" }}>
                        Beratung und Verkauf:
                      </span>
                      <br />
                      <span style={{ fontWeight: "bolder" }}>Mo - Fr</span>{" "}
                      8.00-17.00 Uhr
                      <br />
                      <span style={{ fontWeight: "bolder" }}>Sa</span> Termine
                      nach Absprache
                    </p>
                    <p>
                      <span style={{ fontWeight: "bolder" }}>
                        Warenausgabe:
                      </span>
                      <br />
                      <span style={{ fontWeight: "bolder" }}>Mo - Fr</span>{" "}
                      7.00-13.00 Uhr
                      <br />
                      13.30-15.30 Uhr
                    </p>
                  </RightColumn>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/contactcard.js